<template>
  <!-- 美食 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom
        v-bind:buttonlist="buttonlist"
        v-on:changeDataList="changeDataList"
      ></TopButtom>
    </div>
    <div class="food" v-show="ifShowList">
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">FOOD RECOMMENDATION</div>
        <div class="chinese">美食推荐</div>
      </div>
      <div class="rowA" v-show="deviceId == 2">
        <div class="english">FOOD SPECIALTIES</div>
        <div class="chinese">特色餐饮</div>
      </div>
      <div class="rowA" v-show="deviceId == 3">
        <div class="english">AUTHENTIC FOOD</div>
        <div class="chinese">地道美食</div>
      </div>
      <div class="rowB">
        <div class="body">
          <CardShowList @seeInfo="seeInfo" ref="childCardShow"></CardShowList>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:11px;">武夷山景区</div>
            <div style="margin-top:11px">天下难寻</div>
            <div style="margin-top:11px">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
    <DetailsInfo :info="info" @closed="closed" v-show="!ifShowList"></DetailsInfo>
  </div>
</template>
<script>
import { addHits } from "@/util/publicHits";
import "@/css/listVertical.css";
import TopButtom from "@/components/common/TopButtom.vue";
import CardShowList from "./cardShowList";
import DetailsInfo from "./detailsInfo";
export default {
  name: "TabApage",
  components: { TopButtom, CardShowList ,DetailsInfo},
  data() {
    return {
      ifShowList: true,//是否显示列表
      info: {},
      domKey: "",
      type: "food",
      datalist: [],
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "美食推荐",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "特色餐饮",
          noCheckX: true
        },
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        let timestamp = Date.parse(new Date());
        this.domKey = timestamp;
        this.buttonlist.forEach(element => {
          element.id == deviceId
            ? (element.noCheckX = false)
            : (element.noCheckX = true);
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      this.$store.commit("setTabPage", type);
      let name = "TabFood";
      this.$emit("specialtyListFunction", name);
    },
     //返回
    closed() {
      this.$refs.childCardShow.handleRefresh();
      this.ifShowList = true;
    },
     //详情
    seeInfo(info) {
      if (info.status) {
        if (info.status === 1) {
          //增加点击量
          addHits(info.id);
          this.info = info;
          this.ifShowList = false;
        } else {
          window.open(info.brief)
        }
      } else {
        //增加点击量
        addHits(info.id);
        this.info = info;
        this.ifShowList = false;
      }
    },
  }
};
</script>

<style scoped>
.food {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.food .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.food .rowB {
  width: 100%;
  margin-top: 12.592vh;
  position: relative;
  display: flex;
  flex-direction: column;
  animation: bounceInBottom 2s;
}

.food .rowB .body {
}

.food .rowC {
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.4814vh;
  line-height: 1.57407vh;
  background: #d87001;
  color: #ffffff;
  margin-top: 2.6851vh;
  margin-right: 1.0416vw;
  animation: bounceInRight 2s;
  font-size: 1.2962vh;

}
.food .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}
.food .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.food .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
</style>



// WEBPACK FOOTER //
// src/views/food/tabFood.vue